<template>
  <div id="contact-form" class="contact-form page dark" style="padding-top:100px;">
    <div class="inner" style="display:none">
      <div v-if="sending" style="text-align: center">
        <scale-loader color="#ffffff"/>Sending your message...
      </div>
      <div v-if="sent" text-align="center">
        Thankyou, your message has been sent!
        <br />
        <a href="#" @click="sending=false; sent=false; message=''">Send Another?</a>
      </div>
      <form
        v-if="!sending && !sent"
        method="post"
        action="contactengine.php"
        @submit.prevent="validateBeforeSubmit"
      >
        <!-- <div class="row">
          <div class="label">Subject: </div>
          <div class="field">
            <input type="text" value="Studio Enquiry" />
          </div>
        </div>-->
        <div class="row">
          <div class="label">Your Name:</div>
          <div class="field">
            <input
              v-validate="'required'"
              placeholder="Your Name"
              v-model="name"
              type="text"
              name="Name"
              id="Name"
              :class="[errors.has('Name')?'required':'']"
            >
          </div>
        </div>
        <div class="row">
          <div class="label">Your Email:</div>
          <div class="field">
            <input
              v-validate="'required|email'"
              placeholder="your@email.com"
              v-model="email"
              type="text"
              name="Email"
              id="Email"
              :class="[errors.has('Email')?'required':'']"
            >
          </div>
        </div>
        <div class="row">
          <div class="label">Artist:</div>
          <div class="field">
            <input
              placeholder="Artist's Name (if applicable)"
              v-model="artist"
              type="text"
              name="Artist"
              id="Artist"
            >
          </div>
        </div>
        <!-- <div class="row">
          <div class="label">
            Phone Number:
          </div>
          <div class="field">
            <input type="text" placeholder=""/> 
          </div>
        </div>-->
        <div class="row">Message:</div>
        <div class="row">
          <textarea
            v-validate="'required'"
            v-model="message"
            name="Message"
            id="Message"
            :class="[errors.has('Message')?'required':'']"
          ></textarea>
        </div>
      <div class="errors ">
        <li v-for="error in errors.collect()">{{error[0] }}</li>
      </div>
        <div class="row">
          <input type="submit" value="Send">
        </div>
      </form>

    </div>
    <div class="fbpage">
      <!-- Alternatively, Please feel free to contact us via our <a href="https://www.facebook.com/CopseCornerMusic/">Facebook Page</a> or phone O7595 33787O. -->
      Contact us by Email at
      <a href="mailto:info@copsecorner.co.uk">info@copsecorner.co.uk</a>, through our
      <a href="https://www.facebook.com/CopseCornerMusic/">Facebook Page</a> or phone O7595 33787O.
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { ScaleLoader } from "@saeris/vue-spinners";
export default {
  name: "Contact",
  data: function() {
    return {
      name: "",
      artist: "",
      email: "",
      message: "",
      sending: false,
      sent: false
    };
  },
  components: {
    ScaleLoader
  },
  methods: {
    validateBeforeSubmit() {
      this.$validator.validate().then(result => {
        if (result) {
          // eslint-disable-next-line
          this.sending = true;

          var formData = new FormData();
          formData.append("name", this.name);
          formData.append("artist", this.artist);
          formData.append("email", this.email);
          formData.append("message", this.message);
          axios.post("/contactengine.php", formData).then(response => {
            if (response.data == "SUCESS") {
              this.sending = false;
              this.sent = true;
            } else {
              alert("There was a problem sending your message :(");
              alert(response.data);
            }
          });
          return;
        }

        // alert("Required Fields Missing!");
      });
    }
  }
};
</script>

<style scoped lang="scss">
.fbpage {
  text-align: center;
  padding: 1em;
}
.contact-form {
  min-height: 0;
  textarea {
    width: 100%;
    min-height: 30vh;
    background-color: rgb(41, 27, 36);
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: white;
    font-size: medium;
  }
  input[type="text"],
  input[type="submit"] {
    width: 100%;
    background-color: rgb(41, 27, 36);
    color: white;
    padding: 0.5em;
    font-size: large;
    border: 1px solid rgba(255, 255, 255, 0.2);
  }
  input[type="submit"] {
    &:hover {
      background-color: #444;
      cursor: pointer;
    }
  }
  input.required,
  textarea.required {
    border: 2px solid rgb(189, 71, 71);
  }
  .inner {
    max-width: 1200px;
    margin: 0 auto;

    padding: 0 1%;
  }

  .row {
    display: flex;
    width: 100%;
  }
  .label {
    flex: 1 1 100px;
  }
  .field {
    flex: 1 1 75%;
  }
  a {
    color: white;
    text-decoration: none;
    font-weight: bold;
    &:hover {
      color: pink;
      text-decoration: underline;
    }
  }
}
.errors{
    
    
    li{
        list-style: none;
        border:2px solid rgb(189, 71, 71);;
        background-color:rgb(80, 27, 27);
        padding:0.25em;
        margin-top:0.3em;
        color: rgb(235, 203, 203);
    }
    li:before {
        content: " ✘"; /* Insert content that looks like bullets */
        padding-right: 8px;
        color: rgb(228, 135, 135); /* Or a color you prefer */
        }
}
</style>
